import { withTranslation } from "next-i18next";
import { useState } from "react";
import MenuListButton from "@components/core/MenuListButton";
import { deleteUserList } from "@utils/call-api/userlists-call";
import { useRouter } from "next/router";

function MenuUserListEdit({ openOffcanvasEditUserList, userListUuid, t }) {
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  async function destroyUserList() {
    try {
      setLoading(true);
      await deleteUserList(userListUuid);
      router.replace("/wishlist");
    } catch (err) {
      router.replace("/wishlist");
    }
  }

  return (
    <div className="d-flex flex-column w-100">
      <MenuListButton
        onClick={openOffcanvasEditUserList}
        trackingName="RenameUserlistFromOffcanvas"
      >
        {t("catalog:userlist.rename")}
      </MenuListButton>
      <MenuListButton
        onClick={destroyUserList}
        trackingName="DeleteUserlistFromOffcanvas"
        loading={loading}
      >
        {t("catalog:userlist.delete")}
      </MenuListButton>
    </div>
  );
}

export default withTranslation("catalog")(MenuUserListEdit);
